// extracted by mini-css-extract-plugin
module.exports = {"animationWrapper":"river_animationWrapper__NnAci"};